import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';

interface UserAccess {
  siteId: string;
  cai: string;
  securityLevel: string;
  securityDescription: string;
}

@Component({
    selector: 'app-admin-tlr-administartor-ipeg',
    imports: [
        CommonModule,
        TableModule
    ],
    templateUrl: './admin-tlr-administartor-ipeg.component.html',
    styleUrl: './admin-tlr-administartor-ipeg.component.scss'
})
export class AdminTlrAdministartorIpegComponent implements OnInit {
  users: UserAccess[] = [];
  isLoading = false; // Flag to show loading state
  constructor(private adminService: AdminService) {}
  
  ngOnInit() {
    this.isLoading = true; 
    // Call the admin service to get IPEG report data
    this.adminService.getReportsIPEG().subscribe({
      next: (response) => {
        if (Array.isArray(response)) {
          // Map API response to component data model
          this.users = response.map(item => ({
            siteId: item.SiteID || '',
            cai: item.CAI|| '',
            securityLevel: item.SecurityLevel|| '',
            securityDescription: item.SecurityDescription|| ''
          }));
        } else {
          // Handle empty or non-array response
          console.error('Invalid response format - expected array:', response);
          this.users = [];
        }
        this.isLoading = false; // Set loading to false after data is fetched
      },
      error: (error) => {
        console.error('Error fetching IPEG report data:', error);
        this.users = [];
        this.isLoading = false;
      }
    });
  }
}
